import { useEffect, useRef } from 'react';

// Hook personalizado para manejar el scroll de modales
export const useModalScrollLock = (isOpen: boolean) => {
  const scrollPosition = useRef<number>(0);

  useEffect(() => {
    if (isOpen) {
      // Guardar posición actual
      scrollPosition.current = window.pageYOffset || document.documentElement.scrollTop;
      
      // Bloquear scroll y ocultar scrollbar
      document.body.classList.add('modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition.current}px`;
      document.body.style.width = '100%';
      document.body.style.left = '0';
      document.body.style.right = '0';
      
      // Ocultar scrollbar completamente
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      // Restaurar scroll
      if (document.body.classList.contains('modal-open')) {
        // Restaurar overflow primero
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        
        // Limpiar estilos
        document.body.classList.remove('modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.left = '';
        document.body.style.right = '';
        
        // Restaurar posición instantáneamente
        window.scrollTo({
          top: scrollPosition.current,
          left: 0,
          behavior: 'instant' as ScrollBehavior
        });
      }
    }

    // Cleanup function
    return () => {
      if (document.body.classList.contains('modal-open')) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.left = '';
        document.body.style.right = '';
        
        window.scrollTo({
          top: scrollPosition.current,
          left: 0,
          behavior: 'instant' as ScrollBehavior
        });
      }
    };
  }, [isOpen]);
};